import PropTypes from "prop-types";
import React, { useState } from "react";
import { setActiveSort } from "../../helpers/product";
import { Collapse } from "react-collapse";
import { Link } from "react-router-dom";
import { useEffect } from "react";

const ShopTemplates = ({ templates, getSortParams }) => {
  //const [stateLista, setstateLista] = useState(global.aziendaID == 1? true : false);
  const [stateLista, setstateLista] = useState(false);
  const [templateSelected, setTemplateSelected] = useState(
    JSON.parse(sessionStorage.getItem("filter"))?.templates?.split("|")
  );
  const [refresh, setRefresh] = useState(true);

  const CambioStato = () => {
    if (stateLista) setstateLista(false);
    else setstateLista(true);
  };
  useEffect(() => {
    setTemplateSelected(
      JSON.parse(sessionStorage.getItem("filter"))?.templates?.split("|")
    );
    setRefresh(!refresh);
  }, [sessionStorage.getItem("filter")]);
  return (
    <div className="sidebar-widget">
      <div
        data-role="title"
        role="tab"
        aria-selected="false"
        aria-expanded="false"
        tabindex="-1"
        onClick={() => CambioStato()}
        style={{
          fontSize: "17px",
          color: "black",
          fontWeight: 600,
          cursor: "pointer",
          lineHeight: "30px",
        }}
      >
        <span
          class={
            stateLista
              ? "icon pe-7s-angle-down pull-right"
              : "icon pe-7s-angle-up pull-right"
          }
          data-role="icons"
          style={{ display: "inline-block" }}
        >
          {" "}
        </span>
        Modelli
      </div>

      {/*<div className="shopping-cart-btn btn-hover text-center" style={{ padding: "10px" }}>
        <a style={{ padding: "10px", border: "1px gray solid", display: "block", width: "100%" }} onClick={() => CambioStato()}  >Modelli</a>
  </div>*/}
      {/* <h4  <h4 className="btn btn-primary btn-xs" onClick={() => CambioStato()}>Marchi </h4>*/}

      {/* <h4 className="pro-sidebar-title">Modelli </h4> */}

      <Collapse
        theme={{ collapse: "foo", content: "bar" }}
        isOpened={stateLista}
      >
        <div className="sidebar-widget-tag ">
          {templates ? (
            <ul>
              <li>
                <div className="sidebar-widget-list-left">
                  <button
                    id="allTemplates"
                    onClick={(e) => {
                      document
                        .querySelectorAll(".templates")
                        .forEach((element) =>
                          element.classList.remove("active")
                        );
                      if (e.currentTarget.classList.contains("active"))
                        getSortParams("templates", "all", "-");
                      else getSortParams("templates", "all", "+");
                      //getSortParams("templates", "");
                      setActiveSort(e);
                    }}
                  >
                    <span className="checkmark" /> Tutti i modelli
                  </button>
                </div>
              </li>
              {templates.map((templates, key) => {
                if (templates === "") return;
                return (
                  <li key={key}>
                    <div className="sidebar-widget-list-left">
                      <button
                        className={
                          "templates " +
                          (templateSelected?.find((v) => templates === v)
                            ? "active"
                            : "")
                        }
                        onClick={(e) => {
                          document
                            .querySelector("#allTemplates")
                            .classList.remove("active");
                          if (e.currentTarget.classList.contains("active"))
                            getSortParams("templates", templates, "-");
                          else getSortParams("templates", templates, "+");
                          //getSortParams("templates", templates);
                          setActiveSort(e);
                        }}
                      >
                        {" "}
                        <span className="checkmark" /> {templates}{" "}
                      </button>
                    </div>
                  </li>
                );
              })}
            </ul>
          ) : null}
        </div>
      </Collapse>
    </div>
  );
};

ShopTemplates.propTypes = {
  templates: PropTypes.array,
  getSortParams: PropTypes.func,
};

export default ShopTemplates;
